<!-- Table -->
<div class="custom-table">
  <wm-common-table
    tableType="Staff"
    [columns]="columns"
    [data]="rows"
    [isLoading]="loading"
    [loaderType]="'Circular'"
    [errorMessage]="errorMessage"
  ></wm-common-table>
</div>

<!-- [showRowsPerPage]="true" -->
